import {Theme} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import {themeDarkPoppins} from 'providers/themeDarkPoppins';
import {themePoppins} from 'providers/themePoppins';
import React from 'react';

export const themeContext = React.createContext([
   themePoppins,
   (theme: Theme) => console.debug('Theme changins is not impelmented'),
] as const);

const darkThemeStorageKey = 'darkTheme';
export const useThemeContextBuilder = () => {
   const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

   const [theme, _setTheme] = React.useState(() => {
      const storeVal = localStorage.getItem(darkThemeStorageKey);
      const isDarkMode = storeVal === 'true';
      if (storeVal) {
         return isDarkMode ? themeDarkPoppins : themePoppins;
      }
      return prefersDarkMode ? themeDarkPoppins : themePoppins;
   });

   const setTheme = React.useCallback(
      (theme: Theme) => {
         _setTheme(theme);
         localStorage.setItem(darkThemeStorageKey, String(theme === themeDarkPoppins));
      },
      [_setTheme]
   );

   return [theme, setTheme] as const;
};
